import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { NoteDateGroup } from '@/features/notes/public';
import { NotesPanelItem } from './NotesPanelItem';

interface NotesPanelGroupProps {
  group: NoteDateGroup;
}

/** Collapsible date bucket — same manual-toggle pattern as `SidebarProjects` (no shadcn Accordion in this project). */
export function NotesPanelGroup({ group }: NotesPanelGroupProps) {
  const { t } = useTranslation('layout');
  const [isExpanded, setIsExpanded] = useState(true);

  const label = group.labelKey ? t(group.labelKey) : group.key;

  return (
    <div data-testid={`notes-sidebar-group-${group.key}`}>
      <button
        type="button"
        onClick={() => setIsExpanded((v) => !v)}
        data-testid={`notes-sidebar-group-toggle-${group.key}`}
        className="flex w-full items-center gap-2 px-2 py-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground"
      >
        {isExpanded ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
        {label}
      </button>

      {isExpanded && (
        <div className="flex flex-col gap-0.5">
          {group.notes.map((note) => (
            <NotesPanelItem key={note.id} note={note} />
          ))}
        </div>
      )}
    </div>
  );
}
